export const TaskSortField = {
    NAME: "name",
    DUEDATE: "dueDate"
};

export const SortDirections = {
    ASCENDING: "asc",
    DESCENDING: "desc"
};
